import {ajax} from '../utils/ajaxHelper';

function getReviews({listingId, site, page, pageSize, filter, sort}) { // eslint-disable-line complexity
    const filterParam = filter ? `&${filter}` : '';
    const sortParam = sort ? `&sortBy=${sort}` : '';
    const requestMarker = window && window.debugLog && window.debugLog.requestMarker;
    const variant = window && window.debugLog && window.debugLog.variant;
    const requestMarkerParam = requestMarker ? `&requestMarker=${requestMarker}` : '';
    const variantParam = variant ? `&variant=${variant}` : '';

    const url = `/pdp/reviews?listingId=${listingId}&site=${site}&page=${page}&pageSize=${pageSize}${filterParam}${sortParam}${variantParam}${requestMarkerParam}`;
    // Consider handling the ajax callback here, and mutating the data to something standard.
    return ajax(url);
}

export default getReviews;
export {getReviews};
